import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectPathname } from 'src/redux/navigation/selectors';
import {
  getNextPageNumberNotLoaded,
  getPreviousPageNumberNotLoaded,
} from 'src/redux/products/utils/pageNumbers';
import { adaptStoreToPageURL } from './adaptStoreToPageURL';

export const adaptStoreToPreviousPageURL = (state: ReduxApplicationState): string | null => {
  const previousPageNumber = getPreviousPageNumberNotLoaded(state.products.pages);

  if (previousPageNumber === null) {
    return null;
  }

  const activeSortAndFilterURLParams = adaptStoreToPageURL(state, previousPageNumber);
  const pathname = selectPathname(state);
  const queryString = activeSortAndFilterURLParams.toString();

  return queryString.length > 0 ? `${pathname}?${queryString}` : pathname;
};

export const adaptStoreToNextPageURL = (state: ReduxApplicationState): string | null => {
  const nextPageNumber = getNextPageNumberNotLoaded(
    state.products.pages,
    state.products.totalPages,
  );

  if (nextPageNumber === null) {
    return null;
  }

  const activeSortAndFilterURLParams = adaptStoreToPageURL(state, nextPageNumber);
  const pathname = selectPathname(state);
  const queryString = activeSortAndFilterURLParams.toString();

  return queryString.length > 0 ? `${pathname}?${queryString}` : pathname;
};
